import react, { useEffect, useState } from "react";
import { BRAND_NAMES } from "@/app/utils/utils";
import Image from "next/image";
import { usePathname } from "next/navigation";

const CarConnect = () => {
  const [carModel, setCarModel] = useState("sw4");
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;

    const model = pathname.split("/").pop()?.toLowerCase() || "sw4";
    setCarModel(model);
  }, [pathname]);

  return (
    <div className="grid md:grid-cols-2 gap-8 items-center max-w-4xl mx-auto">
      <div className="space-y-6">
        <h1 className="text-4xl  mb-4">Conectividade</h1>
        <p className=" text-black">
          Tenha a gestão completa do seu carro na palma da sua mão. Monitore a
          saúde do veículo, acompanhe a segurança com rastreamento e cercas
          geográficas, tenha acesso ao status em tempo real e conectividade
          Wi-Fi para vários dispositivos. Tudo integrado para aprimorar sua
          experiência de direção com dados avançados e conectividade
          inteligete.**
        </p>
        <p className="text-base md:text-sm  font-bold text-black">
          **Os Serviços Conectados estão disponíveis exclusivamente para
          veículos que venham com o serviço de fábrica.
        </p>
      </div>

      <div className="p-4">
        <div className="space-y-3">
          <a
            href="https://onelink.to/vnyzmb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              alt={"Carro"}
              src={`https://sablobsitestoyotaprd.blob.core.windows.net/images/Conectividade/conectividade_${carModel}.webp`}
              width={400}
              height={400}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CarConnect;
